<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="10">
                    <h3>Usuários</h3>
                 </b-col>
                 <b-col md="2">
                    <b-button v-if="can('user.store')" @click="navigate('/usuario/cadastrar')" block variant="primary">
                         <i class="fa fa-plus"></i>
                       <span>Novo Usuário</span>
                    </b-button>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Nome, E-mail:">
                        <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome, E-mail"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="3">
                    <b-form-group label="Tipo de Usuário:">
                        <b-form-select v-model="filtros.tipo" placeholder="Tipo de Usuário" class="mb-3">
                              <option selected :value="null">Selecione</option>
                              <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <b-form-group label="Status:">
                            <b-form-checkbox-group v-model="filtros.status" id="checkbox-group-2" name="flavour-2">
                                <b-form-checkbox :value="1">Ativo</b-form-checkbox>
                                <b-form-checkbox :value="0">Inativo</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Nome</th>
                              <th scope="col">Tipo Usuário</th>
                              <th scope="col">E-mail</th>
                              <th scope="col">Status</th>
                              <th scope="col">Ações</th>
                            </tr>
                          </thead>
                          <tbody v-if="usuarios.data !== undefined">
                            <tr v-for="usuario in usuarios.data" :key="usuario.id">
                              <td>{{usuario.nome}}</td>
                              <td>{{usuario.perfil}}</td>
                              <td>{{usuario.email}}</td>
                              <td>
                                <span v-if="usuario.status" class="badge badge-success">Ativo</span>
                                <span v-else class="badge badge-dark">Inativo</span>
                              </td>
                              <td style="width: 15%">
                                  <a tabindex="1" v-if="can('user.update')" class="btn btn-sm btn-secondary action" title="Editar" @click="editarUsuario(usuario.id)">
                                     <i class="fa fa-pencil-square-o"></i>
                                  </a>

                                  <a tabindex="2" v-if="can('user.excluir') && usuario.id !== usuarioCorrente" class="btn btn-sm btn-secondary action" title="Excluir" @click="excluirUsuario(usuario.id, 'excluir')">
                                   <i class="fa fa-times"></i>
                                  </a>

                                   <span v-if="can('user.suspender') && usuario.status">
                                     <a tabindex="3" class="btn btn-sm btn-secondary action" title="Inativar" @click="suspenderUsuario(usuario.id)">
                                      <i class="fa fa-toggle-on"></i>
                                     </a>
                                  </span>

                                  <span v-if="can('user.ativar') && !usuario.status">
                                     <a tabindex="4" class="btn btn-sm btn-secondary action" title="Ativar" @click="ativarUsuario(usuario.id)">
                                      <i class="fa fa-toggle-off"></i>
                                     </a>
                                  </span>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="5">Nenhum registro de usuários...</td>
                           </tr>
                          </tbody>
                         </table>
                         <pagination v-show="usuarios.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                       </span>
                </b-container>
            </b-col>
        </b-row>
      </b-card>
      <b-modal :title="titulo_descricao" size="lg" :ok-title="titulo_botao" cancel-title="Cancelar" v-model="modalPreExcluir" @ok="modalConfirmaExclusao(tipo)">
         <b-card-body>
             <b-form>
             <b-row>
              <b-col cols="4">
                <b-form-group label="CPF:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-mask="'###.###.###-##'"
                                  id="cpf"
                                  type="text"
                                  :disabled="true"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="usuario.cpf"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="UF:">
                  <b-form-select v-model="usuario.estado_id" placeholder="Password" :options="estados"
                                 class="mb-3" :disabled="true">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Município:">
                  <b-form-select placeholder="Password"
                                 :options="cidades"
                                 class="mb-3"
                                 v-model="usuario.cidade_id"
                                 :disabled="true">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="8">
                <b-form-group label="Nome:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model="usuario.nome"
                                  :disabled="true"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Tipo de Usuário:">
                  <b-form-select :disabled="true"
                                 v-model="usuario.perfil_id"
                                 placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (!this.can('user.index')) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('buscarTipoUsuarios')
    }
  },
  data () {
    return {
      usuarioCorrente: parseInt(SessionStorage.get('usuario')),
      tipo: '',
      titulo_confirmacao: '',
      titulo_descricao: '',
      titulo_botao: '',
      totalPorPagina: 5,
      resource: 'usuario',
      modalPreExcluir: false,
      modalSuspender: false,
      modalAtivar: false,
      modalPreAprovar: false,
      situacoes: [
        { value: null, text: 'Selecione' },
        { value: '1', text: 'Aprovado' },
        { value: '0', text: 'Pendente' },
        { value: '2', text: 'Rejeitado' }
      ],
      filtros: {
        situacao: null,
        filter: '',
        tipo: null,
        uf: null,
        municipio: null,
        status: null
      }
    }
  },
  computed: {
    usuarios () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidades
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.tipo': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.status': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarUsuario (id) {
      this.$router.push('/usuario/' + id + '/visualizar')
    },
    editarUsuario (id) {
      this.$router.push('/usuario/' + id + '/editar')
    },
    excluirUsuario (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir esse usuário?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/excluir/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    suspenderUsuario (id) {
      this.$bvModal.msgBoxConfirm('Confirma a inativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/suspender/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    ativarUsuario (id) {
      this.$bvModal.msgBoxConfirm('Confirma a ativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/ativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/Usuarios.vue